module.exports = __webpack_public_path__ + "img/partners.bfa66c45.png";